import React, { useState, useEffect } from "react";
import Notifications from "react-notifications-menu";
//import Menu from "react-select/dist/declarations/src/components/Menu";
import { Container } from './styles.jsx';
import Api, { exceptionNotificationAPI } from "../../services/api";
import moment from "moment";

const NotificationMenu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);

  useEffect(() => {
    changeImgBell()
    getData()
  }, []);

  useEffect(() => {
    var notifications = document.querySelectorAll("div.notifications > div.container > div.items > .card");
    notifications.forEach((not, index) => {
      not.setAttribute("notificationID", data[index].notificationID)
      var notify = data.find(x => x.notificationID == data[index].notificationID);
      if (notify.isRead == false) {
        not.classList.add("not-read")
      }
      not.addEventListener('click', (e) => {
        e.preventDefault();
        markAsRead(notify);        
      })
    })
  }, [loading])

  useEffect(() => {
    const timer = setInterval(async () => {    
      var notificationsIDsList = []
      data.forEach(notify => {
        notificationsIDsList.push(notify.notificationID);
      });
      const user = JSON.parse(localStorage.getItem('@QualityApp:user'));

      await Api.post(`Notification/GetNewNotificationsByUserId`,notificationsIDsList).then((result) => {
        if (result && result.data) {
          var list = [];
          var countNotRead = count;
          result.data.response.map((not) => {
            
            var notIsRead = not.usersIDs.find(x => x.userID == user.id)
            const notification = {
              notificationID: not.notificationID,
              image: "",
              message: not.description,
              detailPage: "",
              receivedTime: moment(not.created).add(moment().utcOffset(), "m").fromNow(),
              isRead: notIsRead != null ? notIsRead.isRead : ""
            }
            if(notification.isRead == false) {
              countNotRead = (countNotRead + 1);
            }
            list.push(notification)
          })
          setData(...data, list)
          var countDiv = document.querySelector(".notifications .count")
          
          if(countDiv == null){
            document.querySelector(".notifications .icon img").insertAdjacentHTML("afterend",`<div class="count">${countNotRead}</div>`);
          }
          else {
            countDiv.innerText = countNotRead;
            if(countNotRead > 0) {
              countDiv.style.display = 'block';
            }
            else {
              countDiv.style.display = 'none';
            }
          }
          
          if(list.length > 0) {
            var notifications = document.querySelectorAll("div.notifications > div.container > div.items > .card");
           
            notifications.forEach((not, index) => {
              not.setAttribute("notificationID", list[index].notificationID)
              var notify = list.find(x => x.notificationID == list[index].notificationID);
              if (notify.isRead == false) {
                not.classList.add("not-read")
                not.addEventListener('click', (e) => {
                  e.preventDefault();
                  markAsRead(notify);        
                })
              }
            })
          }
        }
      }).catch((error) => {
        exceptionNotificationAPI(error);
      })
    }    
    , 180000);
    return () => clearInterval(timer);
  }, []);

  const changeImgBell = () => {
    var bell = "data:image/png;base64,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"
    var elem = document.querySelector(".icon > img");
    elem.setAttribute("src", bell);

    var notifications = document.querySelectorAll(".itens .card");

    notifications.forEach((not) => {
      not.classList.add("not-read");
      not.querySelector(".content .image").style.display = "none";
    })
  }

  const getData = async () => {
    const user = JSON.parse(localStorage.getItem('@QualityApp:user'));
    const userRoles = JSON.parse(localStorage.getItem('@QualityApp:userRoles'));

    await Api.get(`Notification/GetByUserId`).then((result) => {
      if (result && result.data) {
        var list = [];
        var countNotRead = 0;
        result.data.response.map((not) => {
          
          var notIsRead = not.usersIDs.find(x => x.userID == user.id)

          const notification = {
            notificationID: not.notificationID,
            image: "",
            message: not.description,
            detailPage: "",
            receivedTime: moment(not.created).add(moment().utcOffset(), "m").fromNow(),
            isRead: notIsRead.isRead
          }
          if(notification.isRead == false) {
            countNotRead = (countNotRead + 1);
          }
          list.push(notification)
          setCount(countNotRead);
        })
        setData(list)
        var countDiv = document.querySelector(".notifications .count");
        if(countDiv != null) {
          countDiv.innerText = countNotRead;
          if(countDiv.innerText == "0") {
            countDiv.style.display = 'none';
          }
        }
        
        setLoading(false)
      }
    }).catch((error) => {
      exceptionNotificationAPI(error);
    });
  }

  const onReadAll = async () => {
    data.map(async (notify) => {
      await Api.post(`Notification/UpdateIRead?id=${notify.notificationID}`).then((result) => {
        notify.isRead = true;
      })
    })
    var notifications = document.querySelectorAll("div.notifications > div.container > div.items > .card");
    notifications.forEach((not, index) => {      
      not.classList.remove("not-read")      
    })
  };

  const markAsRead = async (notify) => {
    if (notify.isRead == false) {
      await Api.post(`Notification/UpdateIRead?id=${notify.notificationID}`).then((result) => {
              
        notify.isRead = true

        // var allNotify = [];
        // allNotify = data.filter(x => x.notificationID != notify.notificationID)

        // allNotify = [...allNotify, notify]

        // setData(allNotify);

        var selector = '[notificationid="' + notify.notificationID + '"]';
        var notifyHTML = document.querySelector(selector);
        
        notifyHTML.classList.remove("not-read")

        var countDiv = document.querySelector(".notifications .count")
        if(countDiv?.innerText == "0") {
          countDiv.style.display = 'none';
        }
        
      }).catch((error) => {
        exceptionNotificationAPI(error);
      });
    }
  };


  return (
    <>
      <Container>
        <div style={{ marginBottom: 100 }}>
          {
            data != null &&

            <Notifications
              data={data}
              header={{
                title: "Notifications",
                style: { color: "#FFF" },
                option: {
                  text: 'Mark all as read', onClick: () => {
                    onReadAll()
                  }
                }
              }}
              markAsRead={(data) => {
                markAsRead(data.notificationID);
              }}
              headerBackgroundColor='#102A63'
            />
          }
        </div>
      </Container>
    </>
  );
}

export default NotificationMenu;
